import React,{useContext, useState, useRef} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { deleteRequest, getRequest, postRequest } from '../../../api/ApiController';
import { InfoIcon, TaskIcon, ErrorIcon, PermissionIcon, NeedIcon, BorrowItemIcon, EmergencyIcon,ServiceSettingIcon, TechChangeIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import { MultiSelect } from 'primereact/multiselect';
import { Avatar } from 'primereact/avatar';
import { confirmDialog } from 'primereact/confirmdialog';
import { OrderList } from 'primereact/orderlist';


export default function ServiceUsersSettings() {
    
    const [state,dispatch] = useContext(DatabaseContext);
    const {toast,getUserColor,getUserInitials,setDialogText,setVisible} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const submitRef = useRef(null);

    const [,setAddedUser] = useState("");
    const [,setAddedLevel] = useState("");
    const [showAddUser,setShowAddUser] = useState(false);
    const [showAddLevel, setShowAddLevel] = useState(false);
    const [levels, setLevels] = useState([]);
    const [changeOrderOfLevel,setChangeOrderOfLevel] = useState(false);

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
            initialValues: {
                level_id:'',users:[],departments:[],user_department:''
            },
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                setDialogText(t('Common.Saving'));
                setVisible(true);
                let formData = new FormData();
                for (let value in values) {   
                    if (value === "users" || value === "departments") {
                        const arr = values[value];
                        formData.append(value, arr.map(obj => obj.id));
                    }
                    else formData.append(value, values[value] != null ? values[value] : "");
                }
                for (var pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]);
                }
                postRequest('/api/service_user_settings', formData,true)
                .then((response) => {
                    setShowAddUser(false);
                    getRequest("/api/service_user_settings").then((response) => {
                        dispatch({type:'load_service_user_settings',newServiceUserSettings:response.data});
                        formik.resetForm();
                        toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceUsersSettings.UserAddedSuccess') });
                    });
                    setVisible(false);
                }).catch((reason) => {
                    setShowAddUser(false);
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('ServiceTask.ActionFailed'));
                    }
                });
          },
        });

        const formikLevel = useFormik({
            initialValues: {
                name:'', type:'',task:'',
            },
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                setDialogText(t('Common.Saving'));
                setVisible(true);
                let formData = new FormData();
                for (let value in values) {   
                    formData.append(value, values[value] != null ? values[value] : "");
                }
                for (var pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]);
                }
                postRequest('/api/service_levels', formData,true)
                .then((response) => {
                    getRequest("/api/service_levels").then((response) => {
                        dispatch({type:'load_service_levels',newServiceLevels:response.data});
                        formikLevel.resetForm();
                        toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceUsersSettings.LevelAddedSuccess') });
                    });
                    setVisible(false);
                    setShowAddLevel(false);
                    setChangeOrderOfLevel(false);
                }).catch((reason) => {
                    setVisible(false);
                    setShowAddLevel(false);
                    setChangeOrderOfLevel(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('ServiceTask.ActionFailed'));
                    }
                });
          },
        });


    const reject = () => {
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.RequestCancelled'), life: 3000 });
        }
        
    
    const accept = (id) => {
        deleteRequest(`/api/service_user_settings/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceUsersSettings.SettingDeletedSuccess') });
            getRequest("/api/service_user_settings").then((response) => {
                dispatch({type:'load_service_user_settings',newServiceUserSettings:response.data});
            });
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceUsersSettings.DeleteSettingFailed'), life: 3000 });
        })
    };

    const acceptLevel = (id) => {
        deleteRequest(`/api/service_levels/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceUsersSettings.LevelDeletedSuccess') });
            getRequest("/api/service_levels").then((response) => {
                dispatch({type:'load_service_levels',newServiceLevels:response.data});
            });
            getRequest("/api/service_user_settings").then((response) => {
                dispatch({type:'load_service_user_settings',newServiceUserSettings:response.data});
            });
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceUsersSettings.LevelDeleteFailed'), life: 3000 });
        })
    };
    

    function deleteSetting(id){
        confirmDialog({
            message: t('ServiceUsersSettings.ConfirmDeleteSetting'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => accept(id)
        });
    }

    function deleteLevel(id){
        confirmDialog({
            message: t('ServiceUsersSettings.ConfirmDeleteLevel'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptLevel(id)
        });
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <div className="flex-1 flex flex-column gap-2 xl:mr-8">
                    <span className="font-bold">{item.name}</span>
                </div>
                <span className="font-bold text-900">{item.priority}</span>
            </div>
        );
    };

    function setRatings(levels){
        let formData = new FormData();
        formData.append("levels", levels.map(level => level.id));
        postRequest('/api/service_levels/set_ratings', formData,true)
        .then((response) => {
            getRequest("/api/service_levels").then((response) => {
                dispatch({type:'load_service_levels',newServiceLevels:response.data});
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceUsersSettings.OrderSaved') });
            });
            setChangeOrderOfLevel(false);
        }).catch((reason) => {
            alert(t('ServiceTask.ActionFailed'));
            setChangeOrderOfLevel(false);
        });
    }

    function getTask(task){
        const key = {
            approval: 'ServiceUsersSettings.Task.Approval',
            notification: 'ServiceUsersSettings.Task.Notification',
            management: 'ServiceUsersSettings.Task.Management',
            creation: 'ServiceUsersSettings.Task.Creation',
            execution: 'ServiceUsersSettings.Task.Execution',
            inspection: 'ServiceUsersSettings.Task.Inspection',
        }[task];
        return key ? t(key) : '';
    }

    function removeDiacritics(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    const renderLevelsForType = (type) => {
        const levels = state.service_levels.filter((level) => level.type === type);
        if (!levels.length) return null;

        const showExecutionMarker = !['Info', 'Emergency'].includes(type);

        const approvalIndexes = [];
        const inspectionIndexes = [];
        const notificationIndexes = [];

        levels.forEach((l, i) => {
            if (l.task === 'approval')     approvalIndexes.push(i);
            if (l.task === 'inspection')   inspectionIndexes.push(i);
            if (l.task === 'notification') notificationIndexes.push(i);
        });

        const lastApprovalIndex    = approvalIndexes.length ? approvalIndexes[approvalIndexes.length - 1] : -1;
        const firstInspectionIndex = inspectionIndexes.length ? inspectionIndexes[0] : -1;
        const firstNotificationIndex = notificationIndexes.length ? notificationIndexes[0] : -1;

        // Kam vložiť "Vykonanie"
        let executionInsertIndex = null;
        if (showExecutionMarker) {
            if (approvalIndexes.length && inspectionIndexes.length) {
                executionInsertIndex = lastApprovalIndex + 1;           // medzi schvaľovaním a kontrolou
            } else if (approvalIndexes.length) {
                executionInsertIndex = lastApprovalIndex + 1;           // za schvaľovanie
            } else if (inspectionIndexes.length) {
                executionInsertIndex = firstInspectionIndex;            // pred kontrolu
            } else if (notificationIndexes.length) {
                executionInsertIndex = firstNotificationIndex;          // pred notifikácie
            } else {
                executionInsertIndex = levels.length;                   // úplne na koniec
            }
        }

        const lineStyle = { border: 0, borderTop: '2px solid #d4d4d8' }; // plná & o kúsok hrubšia

        // Poskladáme sekvenciu „riadkov“: úrovne + prípadné Vykonanie
        const sequence = [];
        for (let i = 0; i <= levels.length; i++) {
            if (showExecutionMarker && executionInsertIndex === i) {
                sequence.push({ kind: 'execution', key: `${type}-execution-${i}` });
            }
            if (i < levels.length) {
                sequence.push({ kind: 'level', level: levels[i], key: levels[i].id });
            }
        }

        const elements = [];

        const renderLevelBlock = (level) => (
            <React.Fragment key={level.id}>
                <div className="flex justify-between mb-2">
                    <div>
                        <label className="font-bold mb-1 text-lg mr-1">
                            {level?.name}
                        </label>
                        <label className="font-normal mb-1 text-lg">
                            {' - ' + getTask(level?.task)}
                        </label>
                    </div>
                    <div>
                        <button onClick={() => deleteLevel(level?.id)}>
                            <i
                                className="pi pi-trash px-1 py-1"
                                style={{ fontSize: '1.5rem' }}
                            ></i>
                        </button>
                    </div>
                </div>

                <div className="h-auto overflow-y-auto overflow-x-hidden flex flex-col w-full mb-5">
                    {state.service_user_settings
                        .filter((setting) => Number(setting.level_id) === Number(level.id))
                        .map((setting) => (
                            <div
                                key={setting.id}
                                className="flex justify-between items-start gap-10 text-gray-800 mb-2"
                            >
                                <div className="flex flex-row">
                                    <Avatar
                                        className="p-overlay-badge"
                                        title={
                                            setting?.user?.employee?.name ||
                                            setting?.user?.username ||
                                            setting?.department?.name
                                        }
                                        label={getUserInitials(
                                            setting?.user?.employee?.name ||
                                                setting?.user?.username ||
                                                setting?.department?.name
                                        )}
                                        shape="circle"
                                        style={{
                                            backgroundColor: getUserColor(
                                                setting?.user?.username ||
                                                    setting?.department?.name
                                            ),
                                            color: '#ffffff',
                                            marginRight: '5px',
                                        }}
                                    />
                                    <div className="flex justify-left flex-col justify-center">
                                        <span>
                                            {setting?.user?.employee?.name ||
                                                setting?.user?.username ||
                                                setting?.department?.name}
                                        </span>
                                    </div>
                                </div>
                                <div className="px-1">
                                    <button
                                        type="button"
                                        onClick={() => deleteSetting(setting.id)}
                                    >
                                        <i
                                            className="pi pi-times-circle cursor-pointer"
                                            title={t('Common.Delete')}
                                            style={{ fontSize: '1.5rem' }}
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    <div className="text-gray-800">
                        <button
                            type="button"
                            onClick={() => {
                                formik.resetForm();
                                formik.setFieldValue('level_id', level?.id);
                                setShowAddUser(true);
                            }}
                            className="flex items-center gap-2 disabled:opacity-25"
                        >
                            <i
                                className="pi pi-plus mr-2 px-1"
                                style={{ fontSize: '1.5rem' }}
                            ></i>
                            {t('ServiceUsersSettings.AddDepartmentOrUser')}
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );

        // 1) prvá deliaca čiara pod „Pridať úroveň schvaľovania“
        if (sequence.length) {
            elements.push(
                <hr
                    key={`${type}-sep-0`}
                    style={lineStyle}
                    className="mb-4"
                />
            );
        }

        // 2) medzi každým „riadkom“ (úroveň alebo Vykonanie) dáme ďalšiu hr
        sequence.forEach((item, idx) => {
            if (idx > 0) {
                elements.push(
                    <hr
                        key={`${type}-sep-${idx}`}
                        style={lineStyle}
                        className="my-4"
                    />
                );
            }

            if (item.kind === 'execution') {
                elements.push(
                    <div
                        key={item.key}
                        className="text-lg font-semibold tracking-wide"
                    >
                        {t('ServiceUsersSettings.Execution')}
                    </div>
                );
            } else {
                elements.push(renderLevelBlock(item.level));
            }
        });

        return elements;
    };

    return ( 
        <>
        <div className="h-[calc(100vh-136px)] bg-gray-100 overflow-y-auto overflow-x-hidden">
        <div className='xl:columns-3 lg:columns-2 gap-4 space-y-4 m-4'>
            <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <InfoIcon width={8} height={8}/>{t('ServiceTask.Type.Info')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Info' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Info");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                        {renderLevelsForType('Info')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <TaskIcon width={8} height={8}/>{t('ServiceTask.Type.Task')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Task' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Task");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                        {renderLevelsForType('Task')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <TechChangeIcon width={12} height={12}/>{t('ServiceTask.Type.TechChange')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'TechChange' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","TechChange");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                    {renderLevelsForType('TechChange')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <ErrorIcon width={8} height={8}/>{t('ServiceTask.Type.Error')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Error' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-8">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Error");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                        {renderLevelsForType('Error')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <PermissionIcon width={8} height={8}/>{t('ServiceTask.Type.Permission')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Permission' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Permission");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                    </div>
                    {renderLevelsForType('Permission')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <NeedIcon width={8} height={8}/>{t('ServiceTask.Type.Need')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Need' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Need");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                    {renderLevelsForType('Need')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <BorrowItemIcon width={8} height={8}/>{t('ServiceTask.Type.Borrow')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Borrow' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Borrow");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                    {renderLevelsForType('Borrow')}
                    </div>
                    </div>
                </div>
                <div className="w-auto p-6 bg-white rounded-md shadow-md bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 break-inside-avoid">
                <div className='flex flex-row justify-between items-center mb-8'>
                <h1 className="flex flex-row items-center text-3xl font-semibold text-left text-zinc-900">
                   <EmergencyIcon width={8} height={8}/>{t('ServiceTask.Type.Emergency')}
                </h1>
                <button type="button" onClick={() => {setLevels(state.service_levels.filter(level => level.type === 'Emergency' && level.task === 'approval'));setChangeOrderOfLevel(true);}}>
                <ServiceSettingIcon/>
                </button>
                </div>
                <div className='flex flex-col'>
                    <div className="flex flex-col mb-2">
                    <div className='text-gray-800 mb-5'>
                            <button type="button" onClick={() => {formikLevel.resetForm();formikLevel.setFieldValue("type","Emergency");setShowAddLevel(true)}} className='flex items-center gap-2 disabled:opacity-25'>
                                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceUsersSettings.AddApprovalLevel')}
                            </button>
                        </div>
                    {renderLevelsForType('Emergency')}
                    </div>
                    </div>
                </div>
            </div>
            </div>
            <button className='hidden' type='submit' ref={submitRef}></button>
            <Dialog header={t('ServiceUsersSettings.AddDepartmentOrUserDialog')} visible={showAddUser} style={{ width: '50vw' }} onHide={() => {setShowAddUser(false);setAddedUser("");}}>
                <form onSubmit={formik.handleSubmit}>
                <div className='w-auto flex flex-col'>
                <select 
                name='user_department'
                onChange={(e) => {formik.setFieldValue("user_department",e.target.value);formik.setFieldValue("user_id","");formik.setFieldValue("department_id","");}} 
                value={formik.values.user_department}
                className="bg-white block w-full px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                    <option value="">{t('Common.SelectOption')}</option>
                    <option value="department">{t('Common.Department')}</option>
                    <option value="user">{t('Common.User')}</option>
                </select>
                {formik.values.user_department==="department" && <MultiSelect onChange={(e) => formik.setFieldValue("departments",e.target.value)} value={formik.values.departments} 
                    options={state.departments.map((department) => 
                        ({name:department.name,id:department.id})
                    )} 
                    optionLabel="name"
                    filter placeholder={t('ServiceTaskDetail.SelectDepartments')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>}
                {formik.values.user_department==="user" && <MultiSelect onChange={(e) => formik.setFieldValue("users",e.target.value)} value={formik.values.users} 
                    options={state.users.map((user) => 
                        ({name:user?.employee?.name || user?.username,id:user.id,searchLabel: removeDiacritics(user?.employee?.name || user?.username).toLowerCase()})
                    )} 
                    optionLabel="name"
                    filter
            filterBy="searchLabel"
            filterMatchMode="contains"
            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceUsersSettings.SelectUsers')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>} 
                </div>
                <div>
                <button type="submit" disabled={formik.values.users?.length<1 && formik.values.departments?.length<1} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>
                </div>
                </form>
            </Dialog>
            <Dialog header={t('ServiceUsersSettings.AddApprovalLevelDialog')} visible={showAddLevel} style={{ width: '50vw' }} onHide={() => {setShowAddLevel(false);setAddedLevel("");}}>
                <form onSubmit={formikLevel.handleSubmit}>
                    <div className='w-auto flex flex-col'>
                        <label>{t('ServiceUsersSettings.LevelName')}</label>
                        <input
                        name='name'
                        onChange={formikLevel.handleChange} value={formikLevel.values.name}
                        className="block w-full mb-2 px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"></input>
                    </div>
                    <div className='w-auto flex flex-col'>
                        <label>{t('ServiceUsersSettings.LevelTask')}</label>
                        <select 
                        name='task'
                        onChange={formikLevel.handleChange} value={formikLevel.values.task}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value="">{t('Common.SelectOption')}</option>
                            <option value="creation" hidden={state.service_levels.filter(level => level.type===formikLevel.values?.type && level.task==="creation")?.length}>{t('ServiceUsersSettings.Task.Creation')}</option>
                            <option value="management" hidden={state.service_levels.filter(level => level.type===formikLevel.values?.type && level.task==="management")?.length}>{t('ServiceUsersSettings.Task.Management')}</option>
                            <option value="approval">{t('ServiceUsersSettings.Task.Approval')}</option>
                            {/*<option value="execution" hidden={state.service_levels.filter(level => level.type==formikLevel.values?.type && level.task=="execution")?.length || !["Task","Error"].includes(formikLevel.values?.type)}>{t('Ui.R67.Execution')}</option>*/}
                            <option value="inspection" hidden={["Info","Emergency"].includes(formikLevel.values?.type)}>{t('ServiceUsersSettings.Task.Inspection')}</option>
                            <option value="notification" hidden={state.service_levels.filter(level => level.type===formikLevel.values?.type && level.task==="notification")?.length}>{t('ServiceUsersSettings.Task.Notification')}</option>
                        </select>
                    </div>
                    <div>
                    <button type="submit" disabled={formikLevel.values.name==="" || formikLevel.values.task===""} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>
                    </div>
                </form>
            </Dialog>
            <Dialog header={t('ServiceUsersSettings.ChangeLevelOrderDialog')} visible={changeOrderOfLevel} style={{ width: '50vw' }} onHide={() => {setChangeOrderOfLevel(false);}}>
                <div className="card flex flex-col justify-content-center">
                        <OrderList className='w-full' dragdrop dataKey="id" value={levels} onChange={(e) => {setLevels(e.value);}} itemTemplate={itemTemplate} header={t('ServiceUsersSettings.ApprovalLevelsHeader')}></OrderList>
                </div>
                <div>
                    <button type="button" onClick={() => setRatings(levels)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>
                </div>
            </Dialog>
            </> 
            );

}